/**
 * @desc paymentResultsNotice
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.CbsPaymentResponseDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cbaPayment/paymentResultsNotice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
